module.exports = __webpack_public_path__ + "img/dic_local_point_g3.99b97903.gif";